import { useBexApi } from "@shared-ui/bex-api-context";

// Hooks
import useCampaignById from "../hooks/useCampaignById";

// Helper
import { checkValue } from "src/components/common/helper";

interface HotelDataByCampaignProps {
    campaignId: string,
    pageNumber: number,
    enableTripAttach: boolean | undefined,
    displayPropertyCount: boolean | undefined,
    enableLivePricing: boolean | undefined,
    destinationId: string,
}

/**
 * 
 * @param props HotelDataByCampaignProps
 * @returns 
 */
const HotelDataByCampaign = (props: HotelDataByCampaignProps) => {
    const { context } = useBexApi();
    const { campaignId, pageNumber, enableTripAttach, displayPropertyCount, enableLivePricing, destinationId } = props;

    const campaignByIdVariables = {
        context,
        campaignId,
        enableTripAttach: checkValue(enableTripAttach) ? enableTripAttach : false,
        pageNumber,
        userLocation: {},
        displayPropertyCount: checkValue(displayPropertyCount) ? displayPropertyCount : true,
        referrer: undefined,
        enableLivePricing: checkValue(enableLivePricing) ? enableLivePricing : false,
    };

    if (checkValue(destinationId)) {
        campaignByIdVariables['destinationId'] = destinationId;
    }

    const { data, error, loading, fetchMore } = useCampaignById(campaignByIdVariables);

    return  { data, error, loading, fetchMore };
}

export { HotelDataByCampaign, HotelDataByCampaignProps }